import {Component, OnInit} from '@angular/core';
import {AppConstants} from '../../../../helpers/core/AppConstants';
import {ReportService} from '../../../../services/authenticated/report/report.service';
import {Emitters} from '../../../../helpers/core/emitters';
import {ResponseModel} from '../../../../models/response/response.model';
import {DataSharing} from '../../../../helpers/core/data.sharing';
import {FileSystem} from '../../../../helpers/jquery/file.system';
declare var excelExport: any;

@Component({
    selector: 'app-live-asset-report',
    templateUrl: './live.asset.report.component.html',
})

export class LiveAssetReportComponent implements OnInit {
    public level_info:any;
    public _wssp_ids_based:any;
    public submit_data:any;
    constructor(public reportService: ReportService, private emitters: Emitters) {
    }

    ngOnInit() {
        this.level_info = DataSharing.level_info();
        this._wssp_ids_based = false;
        const user_id = DataSharing.user_id();
        // let user_ids = AppConstants.WSSP_USER_IDS; 
        // let exist = user_ids.some(existingId => existingId === user_id);
        const domain_id = DataSharing.domain_id();

if(domain_id=='16'){
            this._wssp_ids_based=true;
        }
    }

    public onSubmit(data) {
        this.getReport(data);
    }

    // public exportReport() {
    //     const id = 'live-asset-report';
    //     excelExport(id, id);
    // }

    public exportReport() {
        let data = this.submit_data;
        data['is_export']=1;
        this.getReport(data);
    }  

    private getReport(data) {
        this.submit_data = data;
        const dataToSend = { ...data };
        const formatDateTime = (dateTimeStr) => {
            const [datePart, timePart, period] = dateTimeStr.split(' '); 
            const [day, month, year] = datePart.split('/'); 
            return `${month}/${day}/${year} ${timePart} ${period}`;
        };
        if (dataToSend.date) {
            dataToSend.date = formatDateTime(dataToSend.date);
        }
        if (dataToSend.end_date) {
            dataToSend.end_date = formatDateTime(dataToSend.end_date);
        }
        this.reportService.liveAsset(dataToSend).then((response: ResponseModel) => {
            if (response.status) {
                if (data['is_export']==1) {
                    FileSystem.downloadFileByGenerateHref(response.data);
                    data['is_export'] = 0;
                } else {
                    this.reportService.reportData = response.data.report_data;
                }
                this.emitters.change({get_report: true});
            }
        });
    }
}
